export enum LoaderStatus {
  None,
  Start,
  Stop,
  Complete
}
